// import styles from "./NewMainComponent.module.css";

// const NewMainComponent = () => {
//   return <div>
//     <div className={styles.homeNew}>
//       <video autoPlay loop muted playsInline preload="auto" className={`${styles.bgVid} desktop`}><source src={"https://ctladmin.b-cdn.net/video/CTL_EUR.mov"} type="video/mp4" /></video>
//       <video autoPlay loop muted playsInline preload="auto" className={`${styles.bgVid} ${styles.mobile}`}><source src={"https://ctladmin.b-cdn.net/video/Timeline%201%20vertical.mov"} type="video/mp4" /></video>
//     </div>
//   </div>
// }

// export default NewMainComponent;

import { useEffect, useState } from "react";
import styles from "./NewMainComponent.module.css";

const NewMainComponent = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480); // Adjust breakpoint as needed
    };

    handleResize(); // Check on initial load
    window.addEventListener("resize", handleResize); // Listen for resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);

  return (
    <div className={styles.homeNew}>
      {(window.innerWidth <= 480 || isMobile) ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className={`${styles.bgVid}`}
        >
          <source
            src="https://ctladmin.b-cdn.net/video/TCTL_EUR_V.mov"
            type="video/mp4"
          />
        </video>
      ) : (
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className={`${styles.bgVid}`}
        >
          <source
            src="https://ctladmin.b-cdn.net/video/CTL_EUR_H.mov"
            type="video/mp4"
          />
        </video>
      )}
    </div>
  );
};

export default NewMainComponent;